import types from "./types";
import originFields from '../../defaults/PointOfOriginFields.json'

const initialState = {
  loaded: false,
  fieldInfos: [],
  perimeterFieldInfos: [],
  sortField: originFields.discoveryDate,
  sortDesc: true
}

const configReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_CONFIG:
      return {
        ...state,
        ...action.payload.config,
        loaded: true
      }
    case types.SET_ORIGIN_FIELD_INFOS:
      return {
        ...state,
        fieldInfos: action.payload.fieldInfos
      }
    case types.SET_SORT_FIELD:
      return {
        ...state,
        sortField: action.payload.sortField
      }
    case types.SET_SORT_DESC:
      return {
        ...state,
        sortDesc: action.payload.sortDesc
      }

    case types.SET_PERIMETER_FIELD_INFOS:
      return {
        ...state,
        perimeterFieldInfos: action.payload.fieldInfos
      }
    default:
      return state;
  }
}

export default configReducer;
